import React from "react";
import {
  MenuItem,
  ListItemText,
  IconButton,
  Select,
  TextField,
  Typography,
  Stack,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Trash, Check } from "@phosphor-icons/react";

const Service = (props) => {
  const theme = useTheme();
  const {
    classes,
    serviceType,
    duration,
    onChangeServiceType,
    onChangeMinutes,
    setError,
    clientInsuranceCodes,
    insuranceCodes,
    maxDuration,
    onClickDelete,
    focusedService,
  } = props;
  const techIssuesCode = insuranceCodes.find((ic) => ic.description.includes("Tech"));
  const nonBillableCode = insuranceCodes.find((ic) => ic.description.includes("Nonbillable Time"));
  return (
    <Stack style={{ position: "relative" }}>
      <div className={classes.editService}>
        <Select
          value={serviceType?.description || ""}
          onChange={onChangeServiceType}
          variant="outlined"
          color="primary"
          displayEmpty
          sx={{ width: 315, height: "40px" }}
          disabled={serviceType?.locked}
          MenuProps={{
            style: { zIndex: 3007 },
          }}
          onFocus={() => setError("serviceTypeError", false)}
          size="small"
        >
          <MenuItem value="" disableGutters disabled>
            <ListItemText primary={"Select service type"} />
          </MenuItem>
          {clientInsuranceCodes.map((code) => (
            <MenuItem key={code.id} value={code.description} disableGutters>
              <ListItemText primary={`${code.description} - ${code.code}`} />
            </MenuItem>
          ))}
          <MenuItem
            key={nonBillableCode?.id}
            value={nonBillableCode?.description}
            disableGutters
            divider
          >
            <ListItemText primary={"Nonbillable Time"} />
          </MenuItem>
          <MenuItem key={techIssuesCode?.id} value={techIssuesCode?.description} disableGutters>
            <ListItemText primary={"Tech Issues"} />
          </MenuItem>
        </Select>
        <TextField
          autoComplete="off"
          value={duration}
          onChange={onChangeMinutes}
          type="number"
          disabled={serviceType?.locked}
          style={{ width: 68 }}
          inputProps={{
            min: 0,
            max: serviceType?.time_limit ? parseInt(serviceType.time_limit) : maxDuration,
          }}
        />
        {serviceType?.locked ? (
          <div className={classes.iconCheckContainer}>
            <Check size={24} color={theme.palette.success.main} />
          </div>
        ) : (
          <IconButton aria-label="Edit" onClick={onClickDelete} size="medium">
            <Trash size={24} color={theme.palette.error.main} />
          </IconButton>
        )}
      </div>
      {focusedService === serviceType.description && (
        <Typography
          variant="captionSecondary"
          alignSelf={"flex-end"}
          sx={{ mr: "45px", position: "absolute", top: "90%", mb: "3px" }}
        >
          Viewing this note
        </Typography>
      )}
    </Stack>
  );
};

export default Service;
